export default function appReducer(state, action, setItem) {
  switch (action.type) {
    case 'SET_USER': {
      setItem('user', action.payload);
      return { ...state, user: action.payload };
    }

    case 'SET_OWN_ESTABLISHMENT': {
      setItem('establishment', action.payload);
      return { ...state, establishment: action.payload };
    }

    case 'SET_ADMIN_TYPE': {
      setItem('adminType', action.payload);
      return { ...state, adminType: action.payload };
    }

    case 'SET_ACTIVE_TAB': {
      return { ...state, activeTab: action.payload };
    }

    case 'SET_POP_NOTIF': {
      return { ...state, notifications: action.payload };
    }

    case 'SET_MODAL': {
      return { ...state, modal: action.payload };
    }

    case 'SET_MODAL_QUERY_LOADING': {
      return { ...state, modalQueryLoading: action.payload };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
